import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DocumentView from 'components/sales/downloadDocView/documentView';
import moment from 'moment';
import parse from 'html-react-parser';

const ViewRmTicket = ({
  fetchRmTicketDetails,
  rmTicketDetails,
  postUpdateRMStatus,
  documentUploadUrl,
  postRmRemark,
  match,
  fetchRmTicketStatus,
  rmStatus,
  location,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [assigneeId, setAssigneeId] = useState('');
  const [isRoleId, setIsRoleId] = useState([]);
  const [remarkData, setRemarkData] = useState({
    rm_ticket_id: match.params.id,
    remarks: '',
    attachment: '',
  });
  const [successModal, setSuccessModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const roles = await JSON.parse(localStorage.getItem('roles'));
        roles.map((obj) => isRoleId.push(obj.id));
        setIsRoleId(isRoleId);
      })();
    }, 1000);
  }, [isRoleId]);

  const handleModalHide = () => setIsModal(false);


  useEffect(() => {
    (async () => {
      if (fetchRmTicketDetails) {
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        await fetchRmTicketStatus();
        setIsLoading(false);
      }
    })();
  }, [fetchRmTicketDetails]);

  const saveReply = async () => {
    if (remarkData.remarks !== '') {
      const res = await postRmRemark(remarkData);
      if (res === true) {
        setIsLoading(true);
        setSuccessModal(true);
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        setIsLoading(false);
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    (() => {
      if (successModal === true) {
        setRemarkData({
          rm_ticket_id: match.params.id,
          remarks: '',
          attachment: '',
        });
      }
    })();
  }, [successModal]);

  const updatePMStatus = async () => {
    const data = {
      rm_ticket_id: match.params.id,
      status: assigneeId,
    };
    if (assigneeId != '') {
      const res = await postUpdateRMStatus(data);
      if (res === true) {
        setIsModal(false);
        setIsLoading(true);
        await fetchRmTicketDetails(match.params.id);
        setIsLoading(false);
      }
    }
  };

  return (
    <Layout
      title={localization.ticketDetails}
      isLoading={isLoading}
      isGoback
      linkUrl={
        match.path.includes('rm-view/')
          ? `${baseUrl}/approvals/rm-tickets`
          : `${baseUrl}/rm-tickets`
      }
    >
      <CardSection title={localization.rmTicket}>
        <div className="details-listing">
          <DivLayout
            heading={localization.ticketId}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.ticket_id}
          />
          <DivLayout
            heading={localization.createdOn}
            data={
              rmTicketDetails &&
              rmTicketDetails.ticket &&
              rmTicketDetails.ticket.created_on.slice(0, 10)
            }
          />
          <DivLayout
            heading={localization.raisedBy}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.created_by}
          />
          <DivLayout
            heading={localization.siteNumber}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.site_no}
          />
          <DivLayout
            heading={localization.siteName}
            data={
              rmTicketDetails.complains && rmTicketDetails.complains.site_name
            }
          />
          <DivLayout
            heading={localization.siteType}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.site_type}
          />

          <DivLayout
            heading={localization.gateNumber}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.gate_no}
          />
          <DivLayout
            heading={localization.assignedTo}
            data={
              rmTicketDetails.ticket &&
              rmTicketDetails.ticket.assigned_to &&
              rmTicketDetails.ticket.assigned_to.name
            }
          />
          <DivLayout
            heading={localization.status}
            data={rmTicketDetails.ticket && rmTicketDetails.ticket.status}
          />

          {rmTicketDetails &&
            rmTicketDetails.mrf_details &&
            rmTicketDetails.mrf_details.length > 0 && (
              <Fragment>
                <h5 className="full-width">{localization.mrf}</h5>
                <table className="panel-table faq-listing">
                  <thead>
                    <tr>
                      <th>{'MRF ID'}</th>
                      <th>{localization.createdOn}</th>
                      <th>{localization.plannedDeliveryDate}</th>
                      <th>{localization.status}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rmTicketDetails.mrf_details.map((obj, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <span className="th">{'MRF ID'}</span>
                            {obj.mrf_id}
                          </td>
                          <td>
                            <span className="th">{localization.createdOn}</span>
                            {obj.created_at}
                          </td>
                          <td>
                            <span className="th">
                              {localization.plannedDeliveryDate}
                            </span>
                            {obj.planned_delivery_date
                              ? obj.planned_delivery_date
                              : localization.na}
                          </td>
                          <td>
                            <span className="th">{localization.status}</span>
                            {obj.status}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Fragment>
            )}
        </div>
      </CardSection>

      <CardSection title={localization.complain}>
        <div className="details-listing">
          <DivLayout
            heading={localization.complainDescription}
            data={
              rmTicketDetails.complains &&
              parse(rmTicketDetails?.complains?.complain_description)
            }
          />
          <DivLayout
            heading={localization.complainType}
            data={
              rmTicketDetails.complains &&
              rmTicketDetails.complains.complain_type
            }
          />
          <DivLayout
            heading={localization.raisedBy}
            data={
              rmTicketDetails.complains &&
              rmTicketDetails.complains.complain_raised_by
            }
          />
          <DivLayout
            heading={localization.gate}
            data={rmTicketDetails.complains && rmTicketDetails.complains.gate}
          />
          <DivLayout
            heading={localization.lastPmDate}
            data={rmTicketDetails.complains && rmTicketDetails.complains.last_pm_date}
          />
          <DivLayout
            heading={localization.lastPmAssignedTo}
            data={
              rmTicketDetails.complains && rmTicketDetails.complains.pm_assigned_to_name 
              ? `${rmTicketDetails.complains.pm_assigned_to_name} (${rmTicketDetails.complains.pm_assigned_to_email})`
              : 'N/A'}
          />
          <DivLayout
            heading={localization.amcType}
            data={rmTicketDetails.complains && rmTicketDetails.complains.amc}
          />
          <DivLayout
          heading={localization.pocName}
          data={rmTicketDetails.complains && rmTicketDetails.complains.name_of_spoc}
          />
            <DivLayout
            heading={localization.phoneNumber}
            data={rmTicketDetails.complains && rmTicketDetails.complains.number_of_poc}
            />
          <DivLayout
            heading={localization.createdOn}
            data={rmTicketDetails?.complains?.created_at}
          />
          <div className="details-list full-width">
              {rmTicketDetails.complains && (rmTicketDetails.complains.document.map((documents) => (
              <DocumentView attachment={documents} />
            )))}
          </div>
        </div>
      </CardSection>
      {rmTicketDetails.complains &&
        rmTicketDetails.complains.troubleshoot &&
        rmTicketDetails.complains.troubleshoot.length > 0 && (
          <div className="panel-card">
            <div className="panel-heading">{localization.troubleshoot}</div>
            <div className="panel-body">
              <div className="form-group">
                <div className="details-listing faq-listing">
                  {rmTicketDetails.complains.troubleshoot &&
                    rmTicketDetails.complains.troubleshoot.questions &&
                    rmTicketDetails.complains.troubleshoot.questions.length &&
                    rmTicketDetails.complains.troubleshoot.questions.map(
                      (obj) => {
                        return (
                          <div className="details-list question-input">
                            <label className="data-title">{obj.question}</label>
                            {obj.answers.length &&
                              obj.answers.map((ele, ind) => {
                                return (
                                  <div className="sub-question" key={ind}>
                                    <label className="label">{ele.label}</label>
                                    <label className="label">
                                      {ele.answer}
                                    </label>
                                  </div>
                                );
                              })}
                          </div>
                        );
                      }
                    )}
                </div>
              </div>
            </div>
          </div>
        )}

      {rmTicketDetails.remarks && rmTicketDetails.remarks.length > 0 && (
        <CardSection title={localization.replies}>
          <div className="details-listing">
            {rmTicketDetails.remarks &&
              rmTicketDetails.remarks.length > 0 &&
              rmTicketDetails.remarks.map((obj) => {
                return (
                  <div className="details-listing reply-box">
                    <div className="details-byline">
                      <div className="details-list">
                        <strong className="data-title">
                          {localization.replyDate}
                        </strong>
                        <span className="data-details">
                          {obj?.created_at &&
                            moment(obj.created_at).format(
                              'DD-MM-YYYY HH:mm:ss'
                            )}
                        </span>
                      </div>
                      <div className="details-list">
                        <strong className="data-title d-none d-md-block">
                          {localization.repliedBy}
                        </strong>
                        <span className="data-details">
                          <span className="d-md-none">By </span>
                          {obj.replied_by}
                        </span>
                      </div>
                    </div>
                    <div className="details-list full-width">
                      <DivLayout
                        heading={localization.response}
                        data={obj.remarks}
                      />
                    </div>
                    {/* {obj.attachment && (
                      <div className="details-list full-width">
                        <DocumentView attachment={obj.attachment} />
                      </div>
                    )} */}
                     <div className="details-list full-width">
                     {obj.attachment && (obj.attachment.map((attachments) => (
                     
                      <DocumentView attachment={attachments} />
                     
                    )))}
                     </div>
                  </div>
                );
              })}
          </div>
        </CardSection>
      )}

      

      <ModalPop
        title={localization.changeStatus}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <h5>{localization.pleaseConfirmStatus}</h5>
          <DropDownInput
            label={localization.selectStatus}
            required
            isStarRequired={true}
            data={isRoleId.includes(9) ? [{ id: 3, name: 'Closed' }] : rmStatus}
            errorMsg={localization.isRequired}
            getIdValue={(val) => setAssigneeId(val.id)}
          />

          <Button
            className="btn btn-primary mb-4"
            onClick={() => updatePMStatus()}
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={successModal}
        handleModalHide={() => {
          setSuccessModal(false);
        }}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.repliedSuccessfully}</h5>
          <Button
            onClick={() => {
              setSuccessModal(false);
            }}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ViewRmTicket;
